import * as React from "react";
import { IconChevronLeft } from "../../components/icons.jsx";
import { EventToast } from "./EventToast.jsx";
import "./event-shop.css";

const number = value => Number(value).toLocaleString("ru-RU");
const resources = {
  spins: { title: "Крутки", unit: "круток", image: "/assets/resource-emojis/card.webp" },
  cases: { title: "Ивентовые кейсы", unit: "ивентовых кейсов", image: "/assets/case-halloween.webp" },
  crystals: { title: "Кристаллы", unit: "кристаллов", image: "/assets/resource-emojis/crystal.webp" },
};
const caseUnits = { one: "ивентовый кейс", few: "ивентовых кейса", many: "ивентовых кейсов", other: "ивентовых кейсов" };
const plurals = new Intl.PluralRules("ru-RU");

export function EventShopPage({ event, items, busy, loading, onBuy, onBack, showBack, error, notice, onDismissNotice, onReload }) {
  return <section className="halloween-event-page halloween-shop-page" aria-label="Магазин события" aria-busy={loading || !!busy}>
    {showBack && <button type="button" className="event-shop-back" onClick={onBack}><IconChevronLeft aria-hidden="true" />К событию</button>}
    <EventToast message={notice} onDismiss={onDismissNotice} />
    {error && <div className="event-shop-error" role="alert"><p>{error}</p><button type="button" disabled={loading || !!busy} onClick={onReload}>Обновить</button></div>}
    <EventShop {...{ event, items, busy, loading, onBuy }} />
  </section>;
}

export function EventShop({ event, items, busy, loading, onBuy }) {
  const [selected, setSelected] = React.useState(null);
  const [category, setCategory] = React.useState("spins");
  const item = items.find(value => value.id === selected);
  return <section className="event-currency-shop" aria-label="Магазин за валюту события" data-category={category}>
    <header className="event-shop-hero"><small>СОКРОВИЩА ХЭЛЛОУИНА</small><h2>Лавка ночи</h2>
      <div className="event-shop-wallet"><span><img src="/assets/home-halloween/pumpkin-v2.webp" alt="" />{event.currencyName}</span><b>{number(event.currency)}</b></div>
    </header>
    {!event.active && <p role="status">Событие завершено. Обмен сейчас недоступен.</p>}
    <div className="event-shop-categories" role="group" aria-label="Категории магазина">{Object.entries(resources).map(([key, resource]) => <button type="button" key={key}
      aria-pressed={category === key} disabled={!!busy} onClick={() => { setCategory(key); setSelected(null); }}><img src={resource.image} alt="" />{key === "cases" ? "Кейсы" : resource.title}</button>)}</div>
    <section className="event-shop-products" aria-label={resources[category].title}>
      <div className="event-shop-grid">{items.filter(value => value.resource === category).map(value => <button type="button" key={value.id}
        className="event-shop-item" aria-pressed={selected === value.id} disabled={!!busy || loading || !event.active || value.price <= 0}
        onClick={() => setSelected(value.id)}>
        <span className="event-shop-item-art"><img src={resources[category].image} alt="" /></span>
        <b>{number(value.amount)}<small>{category === "cases" ? caseUnits[plurals.select(value.amount)] : resources[category].unit}</small></b>
        <span className="event-shop-item-price">{value.price > 0 ? <>{event.currencyEmoji} {number(value.price)}</> : "Недоступно"}</span>
      </button>)}</div>
    </section>
    {!items.length && <p>Товары пока недоступны. Обнови событие.</p>}
    <div className={`event-shop-confirm${item ? " has-selection" : ""}`} aria-live="polite">{item ? <>
      <b>{resources[item.resource].title}: {number(item.amount)}</b>
      <p>Стоимость: {number(item.price)} {event.currencyEmoji} · Остаток: {number(Math.max(0, event.currency - item.price))}</p>
      <button type="button" className="halloween-event-buy" disabled={!!busy || loading || !event.active || item.price <= 0 || event.currency < item.price}
        onClick={() => onBuy(item)}>{busy === `shop:${item.id}` ? "Покупаем…" : `Купить за ${number(item.price)} ${event.currencyEmoji}`}</button>
      {event.currency < item.price && <small>Не хватает {number(item.price - event.currency)} {event.currencyEmoji}</small>}
    </> : <div className="event-shop-prompt"><img src="/assets/home-halloween/pumpkin-v2.webp" alt="" /><div><b>Твои тыквы — твои сокровища</b><p>Выбери награду для обмена</p></div></div>}</div>
  </section>;
}
